import { CircularProgress, type CircularProgressProps } from '@mui/material'
import React, { ReactElement } from 'react'

interface Props extends CircularProgressProps {
  primaryColor: string
  secondaryColor: string
}

const GradientCircularProgress = (props: Props): ReactElement => {
  const { primaryColor, secondaryColor } = props
  return (
    <React.Fragment>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor={primaryColor} />
            <stop offset="100%" stopColor={secondaryColor} />
          </linearGradient>
        </defs>
      </svg>
      <CircularProgress
        sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }}
        {...props}
      />
    </React.Fragment>
  )
}

export default GradientCircularProgress
